import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {ServiceBranchOffice} from './service-branch-office.model';
import * as ServiceBranchOfficeActions from './service-branch-office.actions';

export const serviceBranchOfficesFeatureKey = 'serviceBranchOffices';

export interface State extends EntityState<ServiceBranchOffice> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ServiceBranchOffice> = createEntityAdapter<ServiceBranchOffice>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ServiceBranchOfficeActions.addServiceBranchOffice,
    (state, action) => adapter.addOne(action.serviceBranchOffice, state)
  ),
  on(ServiceBranchOfficeActions.upsertServiceBranchOffice,
    (state, action) => adapter.upsertOne(action.serviceBranchOffice, state)
  ),
  on(ServiceBranchOfficeActions.addServiceBranchOffices,
    (state, action) => adapter.addMany(action.serviceBranchOffices, state)
  ),
  on(ServiceBranchOfficeActions.upsertServiceBranchOffices,
    (state, action) => adapter.upsertMany(action.serviceBranchOffices, state)
  ),
  on(ServiceBranchOfficeActions.updateServiceBranchOffice,
    (state, action) => adapter.updateOne(action.serviceBranchOffice, state)
  ),
  on(ServiceBranchOfficeActions.updateServiceBranchOffices,
    (state, action) => adapter.updateMany(action.serviceBranchOffices, state)
  ),
  on(ServiceBranchOfficeActions.deleteServiceBranchOffice,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ServiceBranchOfficeActions.deleteServiceBranchOffices,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ServiceBranchOfficeActions.loadServiceBranchOffices,
    (state, action) => adapter.setAll(action.serviceBranchOffices, state)
  ),
  on(ServiceBranchOfficeActions.clearServiceBranchOffices,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
